import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ArrowDown } from '../../assets/images/icons';
import { styled } from '@mui/material/styles';

const MyFilter = styled(Box)(({ theme }) => ({
  height: '38px',
  width: 110,
  borderRadius: '28px',
  textTransform: 'uppercase',
  fontSize: '12px',
  fontWeight: '800',
  background: 'rgb(255, 242, 242)',
  padding: '0px 16px 0px 16px',
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.secondary.main,
  justifyContent: 'space-between',
  position: 'relative',
  cursor: 'pointer',
  [theme.breakpoints.only('xs')]: {
    width: '49%',
    margin: '0'
  },
  ".show-filter svg": {
    width: 16,
    "path": {
      stroke: theme.palette.secondary.main
    }
  },
  ".rest-items": {
    position: 'absolute',
    width: '100%',
    height: 'auto',
    top: 38,
    left: 0,
    zIndex: 100,
    background: '#fff',
    boxShadow: '0px 5px 6px -7px rgba(0, 0, 0, 0.35), 0px 4px 14px -3px rgba(0, 0, 0, 0.15)',
    borderRadius: '0 0 19px 19px',
    display: 'none',
    color: theme.palette.primary.main,
    padding: '1px 0 4px',
    "&:before": {
      content: '""',
      width: '100%',
      height: 5,
      position: 'absolute',
      top: -5,
      left: 0,
      background: '#fff'
    }
  },
  "&.opened": {
    background: '#fff',
    borderRadius: '19px 19px 0 0',
    boxShadow: '0px 5px 6px -7px rgba(0, 0, 0, 0.35), 0px 4px 14px -3px rgba(0, 0, 0, 0.15)',
    color: theme.palette.primary.main,
    ".rest-items": {
      display: 'block',
      " > .MuiBox-root": {
        padding: '4px 6px 4px 16px',
        margin: '0 0 2px',
        "&:hover": {
          color: theme.palette.secondary.main,
          background: 'rgb(255, 242, 242)',
        }
      }
    },
    ".show-filter svg path": {
      stroke: theme.palette.primary.main
    }
  }
}))

const MyItem = styled(Box)(({ theme }) => ({
  whiteSpace: 'nowrap'
}))

const CustomFilter = ({filterSystems, activeFilter, setActiveFilter, defaultText, styles = {}}) => {

  const [showFilter, setShowFilter] = useState(false);

  let options = [];
  filterSystems.forEach((value, key) => {
    options.push(<MyItem 
      key={key} 
      onClick={() => setActiveFilter(key)}
      sx={{display: (activeFilter === key || activeFilter === null && key === 'ALL') ? 'none' : 'inherit'}}
    >
      {value}
    </MyItem>)
  });

  return (
    <MyFilter
      onClick={() => setShowFilter(!showFilter)}
      className={showFilter && ' opened '}
      sx={styles}
    >
      <MyItem>{activeFilter === null ? defaultText : filterSystems.get(activeFilter)}</MyItem>
      <Box className="show-filter"><ArrowDown flip={showFilter ? "true" : undefined} /></Box>
      <Box className={`rest-items`}>
        {options}
      </Box>
    </MyFilter>
  )
}

export default CustomFilter